import React from "react";
import { Link } from "react-router-dom";
import { ArrowLeft, FilePdf, DownloadSimple } from "@phosphor-icons/react";

const PAGES = [1, 2, 3, 4];
const PDF_URL = "/docs/firewatch-features-and-comparison.pdf?v=202607b";

export default function ComparePage() {
  return (
    <div className="min-h-screen bg-tac-bg" data-testid="compare-page">
      <div className="max-w-4xl mx-auto px-4 py-8">
        <Link
          to="/about"
          data-testid="compare-back-link"
          className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider text-tac-dim hover:text-tac-text transition-colors"
        >
          <ArrowLeft size={13} weight="bold" /> Back to About
        </Link>

        <div className="flex flex-wrap items-end justify-between gap-3 mt-4 mb-6">
          <div>
            <h1 className="text-2xl sm:text-3xl font-black text-tac-text">
              Features &amp; Comparison Guide
            </h1>
            <p className="text-sm text-tac-dim mt-1">
              Everything Firewatch does, and how it stacks up against Watch Duty. Updated July 2026.
            </p>
          </div>
          <a
            href={PDF_URL}
            download="firewatch-features-and-comparison.pdf"
            data-testid="compare-download-pdf"
            className="inline-flex items-center gap-2 px-4 py-2 bg-tac-primary text-white rounded-sm text-xs font-bold uppercase tracking-wider hover:bg-tac-primary/90 transition-colors"
          >
            <DownloadSimple size={14} weight="bold" /> Download PDF
          </a>
        </div>

        <div className="space-y-6">
          {PAGES.map((n) => (
            <img
              key={n}
              src={`/docs/firewatch-comparison-${n}.png?v=202607b`}
              alt={`Features & comparison — page ${n}`}
              data-testid={`compare-page-img-${n}`}
              loading={n > 1 ? "lazy" : "eager"}
              className="w-full border border-tac-border rounded-sm shadow-lg shadow-black/40"
            />
          ))}
        </div>

        <div className="mt-8 text-center">
          <a
            href={PDF_URL}
            download="firewatch-features-and-comparison.pdf"
            className="inline-flex items-center gap-2 text-[12px] font-bold uppercase tracking-wider text-tac-primary hover:text-tac-text transition-colors"
          >
            <FilePdf size={14} weight="fill" /> Download the PDF version
          </a>
        </div>
      </div>
    </div>
  );
}
